import React from 'react';
import { BilateralContainerLayoutStyleListTypes } from '../../../utils/utils';
import './bilateralContainerLayout.scss';

const BilateralContainerLayout = ({ children, layoutStyle, ...props }) => {
  const getLayoutStyle = (style) => {
    switch (style) {
      case BilateralContainerLayoutStyleListTypes.BILATERALSTYLE1:
        return 'style-1';
      case BilateralContainerLayoutStyleListTypes.BILATERALSTYLE2:
        return 'style-2';
      case BilateralContainerLayoutStyleListTypes.BILATERALSTYLE3:
        return 'style-3';
      case BilateralContainerLayoutStyleListTypes.BILATERALSTYLE4:
        return 'style-4';
      case BilateralContainerLayoutStyleListTypes.BILATERALSTYLE5:
        return 'style-5';
      default:
        return '';
    }
  };
  return (
    <div className={`biLateral-container ${getLayoutStyle(layoutStyle)}`}>
      <div className="container">{children}</div>
    </div>
  );
};

export default BilateralContainerLayout;
